import { useEffect, useRef, useState } from 'react';
import { getSyncStatus, syncEnv } from '../../../../api/game/env';
import { IGameEnvModel, IGameEnvSync } from '../../../../model/api-modules/env';
import errorIcon from '../../../../assets/svg/fail-sync-big.svg';
import { GameSyncStep } from './game-sync-step';
import { StepStatus } from '../../../../model/config';
import { Button, Drawer } from 'antd';
import closeIcon from '../../../../assets/svg/close-icon.svg';
import { ModalWrap } from '../../../component/modal-wrap';
import warnImage from '../../../../assets/images/warn-yellow.png';
import getFormatMessage from '../../../../locales/get-format-message';
import { CommonStatusStep, IAuditItem } from '../../../../model/api-modules';
import { auditWriteLog } from '../../../lib/aduit-log';
import { reportPageError } from '../../../lib/bk-report';
interface IProps {
  readonly syncData: IGameEnvSync;
  // setBtnLoading?: (loading: boolean) => void;
  // modalVisible?: boolean;
  // isSyncContent?: boolean;

  readonly closeModal: () => void;
  readonly changeConfirmStep: (value: CommonStatusStep) => void;
  readonly closeConfirmModal: () => void;
  readonly envList: ReadonlyArray<IGameEnvModel>;
}
interface IStep {
  readonly title: string;
  readonly description: {
    readonly text1?: string;
    readonly text2?: string;
    readonly textSuccess?: string;
    readonly textFail?: string;
    readonly buttonText?: string;
    readonly onButtonClick?: () => void;
    readonly buttonSuccessText?: string;
    readonly buttonFailText?: string;
    readonly onButtonSuccessClick?: () => void;
    readonly onButtonFailClick?: () => void;
  };
  status: StepStatus;
}
// 同步升级的三种情况
export const EnvSyncDetail = (props: IProps) => {
  const { closeModal, syncData, changeConfirmStep, closeConfirmModal } = props;
  const [modalContent, setModalContent] = useState<string | JSX.Element>('');
  const [isTargetHigh, setIsTargetHigh] = useState<boolean>(false);
  const [current, setCurrent] = useState<number>(0);
  const [isUpGrade, setIsUpGrade] = useState<boolean>(false);
  const [isStatusUpdated, setIsStatusUpdated] = useState<boolean>(false);
  const [stepsSame, setStepsSame] = useState<IStep[]>([]);
  const [syncDataForce, setSyncDataForce] = useState<IGameEnvSync>();
  // 二次确认关闭的弹窗
  const [confirmDiscardModal, setConfirmDiscardModal] =
    useState<boolean>(false);
  // 任务是否结束
  const [isDone, setIsDone] = useState<boolean>(false);

  // 情况二：目标版本偏低
  const stepsTwo: IStep[] = [
    {
      title: getFormatMessage('check_env'),
      description: {
        text1: getFormatMessage('continue_anyway'),
        text2: getFormatMessage('lower_version_upgrade_desc'),
        buttonText: getFormatMessage('continue'),
        onButtonClick: () => {
          // 二次确认同步
          setIsUpGrade(true);
        },
      },
      status: StepStatus.Progress,
    },
    {
      title: getFormatMessage('config_sync'),
      description: {
        text1: getFormatMessage('being_sync_desc'),
        text2: getFormatMessage('not_close_desc'),
        textSuccess: getFormatMessage('sync_success'),
        textFail: getFormatMessage('sync_fail'),
        buttonFailText: getFormatMessage('cancel'),
        onButtonFailClick: () => {
          onCloseSyncTask();
        },
      },
      status: StepStatus.Progress,
    },
    {
      title: getFormatMessage('service_upgrade'),
      description: {
        text2: getFormatMessage('being_sync_desc'),
        textSuccess: getFormatMessage('sync_success'),
        textFail: getFormatMessage('upgrade_fail'),
        buttonSuccessText: getFormatMessage('i_know'),
        buttonFailText: getFormatMessage('cancel'),
        onButtonSuccessClick: () => {
          onCloseSyncTask();
        },
        onButtonFailClick: () => {
          onCloseSyncTask();
        },
      },
      status: StepStatus.Progress,
    },
  ];
  // 情况三:版本一致
  const stepsThree: IStep[] = [
    {
      title: getFormatMessage('check_env'),
      description: {
        text2: getFormatMessage('env_check_progress'),
      },
      status: StepStatus.Progress,
    },
    {
      title: getFormatMessage('config_sync'),
      description: {
        text1: getFormatMessage('being_sync_desc'),
        text2: getFormatMessage('not_close_desc'),
        textSuccess: getFormatMessage('sync_success'),
        textFail: getFormatMessage('sync_fail'),
        buttonSuccessText: getFormatMessage('i_know'),
        buttonFailText: getFormatMessage('cancel'),
        onButtonSuccessClick: () => {
          onCloseSyncTask();
        },
        onButtonFailClick: () => {
          onCloseSyncTask();
        },
      },
      status: StepStatus.Progress,
    },
  ];
  const onOkSync = async () => {
    setIsDone(true);
    const syncParams = syncData;
    try {
      if (syncData.transparentData?.services?.length === 0) {
        return;
      }
      const res = await syncEnv(syncParams);
      const envItem = props.envList.find(
        (item) => item.id === syncParams.targetEnvID
      );
      if (envItem) {
        auditWriteLog(IAuditItem.GameEnvironmentSync, {
          gameID: syncParams.gameID.toString(),
          envID: envItem.Guid,
          envType: envItem.Type,
          detail: {
            ...syncParams,
            gameID: syncParams.gameID.toString(),
            envID: envItem.Guid,
          },
        });
      }
      if (res?.code === 0) {
        // 情况三：版本一致，可以同步升级
        setStepsSame(stepsThree);
        const taskID = res.result?.task_id;
        if (taskID) {
          handleSyncStatus(taskID);
        }
        // 成功直接关闭 打开新提示弹窗 失败则原逻辑展示
        changeConfirmStep(CommonStatusStep.Resolve);
        closeModal();
      } else {
        closeConfirmModal();
        // 其他情况
        console.log('error其他情况');
        setIsTargetHigh(true);
        setModalContent(failContent());
        setIsDone(false);
      }
    } catch (error: any) {
      closeConfirmModal();
      if (error?.apiError?.code === 50004 || error?.apiError?.code === 10024) {
        // 情况二：目标版本偏低，需要二次确认同步升级
        syncParams.force = 1;
        setSyncDataForce(syncParams);
        setStepsSame(stepsTwo);
        console.log('50004 || 10024');
      } else if (
        error?.apiError?.code === 50002 ||
        error?.apiError?.code === 10023
      ) {
        console.log('50002 || 10023');
        // 情况一：目标版本偏高，不能升级和同步，出现提示
        setIsTargetHigh(true);
        setModalContent(failContent(50002));
        setIsDone(false);
      } else if (error?.apiError?.code === 50003) {
        console.log('50003');
        // 情况三：内部错误，缺少必要的数据或配置, 不能升级和同步
        setIsTargetHigh(true);
        setModalContent(failContent(50003));
        setIsDone(false);
      } else {
        setIsTargetHigh(true);
        setModalContent(failContent());
        setIsDone(false);
      }
    }
  };
  // 情况二500004需要先二次确认
  const handlerSyncForce = async () => {
    console.log('isUpGrade', isUpGrade);
    let updatedSteps: IStep[] = [];
    try {
      // 更新步骤状态
      updatedSteps = [...stepsTwo];
      updatedSteps[0].status = StepStatus.Finished;
      updatedSteps[1].status = StepStatus.Waiting;
      setCurrent(1);
      setStepsSame(updatedSteps);
      console.log('syncDataForce=', syncDataForce);
      if (syncDataForce) {
        const res = await syncEnv(syncDataForce);
        const envItem = props.envList.find(
          (item) => item.id === syncDataForce.targetEnvID
        );
        if (envItem) {
          auditWriteLog(IAuditItem.GameEnvironmentSync, {
            gameID: syncDataForce.gameID.toString(),
            envID: envItem.Guid,
            envType: envItem.Type,
            detail: {
              ...syncDataForce,
              gameID: syncDataForce.gameID.toString(),
              envID: envItem.Guid,
            },
          });
        }
        if (res?.code === 0) {
          // force=1成功：说明生成同步+升级任务建立是成功的
          const taskID = res.result?.task_id;
          if (taskID) {
            // 开始进行同步和升级
            setTimeout(() => {
              handleSyncUpgrade(taskID);
            }, 1000);
          }
          // 成功直接关闭 打开新提示弹窗 失败则原逻辑展示
          changeConfirmStep(CommonStatusStep.Resolve);
          closeModal();
        } else {
          closeConfirmModal();
          // 任务建立失败
          updatedSteps[1].status = StepStatus.Fail;
          setCurrent(1);
          setStepsSame(updatedSteps);
          setIsDone(false);
        }
      }
    } catch (error: any) {
      closeConfirmModal();
      console.log('The sync operation has failed:', error);
      updatedSteps[1].status = StepStatus.Fail;
      setCurrent(1);
      setStepsSame(updatedSteps);
      setIsDone(false);
    }
  };
  // 50004的同步+升级方法
  const intervalHandle = useRef<null | NodeJS.Timeout>(null);
  const handleSyncUpgrade = async (taskId: number) => {
    const updatedSteps = stepsSame;
    try {
      intervalHandle.current = setInterval(() => {
        getSyncStatus(syncData.gameID as string, taskId)
          .then((statusResult) => {
            if (statusResult.code === 0) {
              let statusSync; // 先同步
              let statusUpgrade; // 再升级
              statusResult.result?.forEach((result) => {
                if (result.task_index === 1) {
                  statusSync = result.status;
                } else if (result.task_index === 2) {
                  statusUpgrade = result.status;
                }
              });
              if (statusSync !== undefined) {
                console.log('statusSync ==', statusSync);
                console.log('statusUpgrade ==', statusUpgrade);
                if (statusSync > 1) {
                  if (statusSync === 2) {
                    // 同步成功
                    updatedSteps[0].status = StepStatus.Finished;
                    updatedSteps[1].status = StepStatus.Finished;
                    updatedSteps[2].status = StepStatus.Waiting;
                    // 同步判断为成功再看升级
                    setCurrent(2);
                    setStepsSame(updatedSteps);
                    setIsStatusUpdated(true);
                    if (statusUpgrade !== undefined && statusUpgrade > 1) {
                      clearInterval(intervalHandle.current as NodeJS.Timeout); // 升级结束，终止轮循定时调用
                      if (statusUpgrade === 2) {
                        // 升级成功
                        updatedSteps[2].status = StepStatus.Success;
                      } else {
                        updatedSteps[2].status = StepStatus.Fail;
                      }
                      setStepsSame(updatedSteps);
                      setIsStatusUpdated(true);
                      setIsDone(false);
                    }
                  } else {
                    // 同步失败，不再进行升级
                    clearInterval(intervalHandle.current as NodeJS.Timeout); // 同步结束，终止轮循定时调用
                    updatedSteps[1].status = StepStatus.Fail;
                    updatedSteps[2].status = StepStatus.Progress;
                    setCurrent(1);
                    setStepsSame(updatedSteps);
                    setIsStatusUpdated(true);
                    setIsDone(false);
                  }
                }
              }
            } else {
              updatedSteps[0].status = StepStatus.Finished;
              updatedSteps[1].status = StepStatus.Fail;
              updatedSteps[2].status = StepStatus.Progress;
              setCurrent(1);
              setStepsSame(updatedSteps);
              setIsStatusUpdated(true);
              setIsDone(false);
            }
          })
          .catch((error) => {
            console.log('The sync operation has failed:', error);
            updatedSteps[0].status = StepStatus.Finished;
            updatedSteps[1].status = StepStatus.Fail;
            updatedSteps[2].status = StepStatus.Progress;
            setStepsSame(updatedSteps);
            setIsStatusUpdated(true);
            setIsDone(false);
            reportPageError(error);
          });
      }, 3000); // 每3秒调用一次
    } catch (error) {
      console.log('The sync operation has failed:', error);
      updatedSteps[0].status = StepStatus.Finished;
      updatedSteps[1].status = StepStatus.Fail;
      updatedSteps[2].status = StepStatus.Progress;
      setStepsSame(updatedSteps);
      setIsStatusUpdated(true);
      setIsDone(false);
    }
  };
  // 一致的同步方法
  // let count = 0;
  const handleSyncStatus = async (taskId: number) => {
    let updatedSteps: IStep[] = [];
    try {
      // 版本一致,code=0
      updatedSteps = [...stepsThree];
      updatedSteps[0].status = StepStatus.Finished;
      updatedSteps[1].status = StepStatus.Waiting;
      setCurrent(1);
      setStepsSame(updatedSteps);

      intervalHandle.current = setInterval(() => {
        getSyncStatus(syncData.gameID as string, taskId)
          .then((statusResult) => {
            if (statusResult.code === 0) {
              console.log('statusResult ==', statusResult);
              // 只有一个result
              const statusSync = statusResult.result?.[0]?.status;
              // const statusUpgrade = statusResult.result?.[1]?.status;
              if (statusSync !== undefined) {
                // console.log('statusSync ==', statusSync);
                if (statusSync > 1) {
                  clearInterval(intervalHandle.current as NodeJS.Timeout); // 终止轮循定时调用
                  if (statusSync === 2) {
                    updatedSteps[1].status = StepStatus.Success;
                  } else {
                    updatedSteps[1].status = StepStatus.Fail;
                  }
                  setStepsSame(updatedSteps);
                  setIsStatusUpdated(true);
                  setIsDone(false);
                }
              }
            } else {
              updatedSteps[1].status = StepStatus.Fail;
              setStepsSame(updatedSteps);
              setIsStatusUpdated(true);
              setIsDone(false);
            }
          })
          .catch((error) => {
            console.log('The sync operation has failed::', error);
            updatedSteps[1].status = StepStatus.Fail;
            setStepsSame(updatedSteps);
            setIsStatusUpdated(true);
            setIsDone(false);
          });
      }, 3000); // 每3秒调用一次
    } catch (error) {
      console.log('The sync operation has failed:', error);
      updatedSteps[1].status = StepStatus.Fail;
      setStepsSame(updatedSteps);
      setIsStatusUpdated(true);
      setIsDone(false);
    }
  };

  useEffect(() => {
    if (isStatusUpdated) {
      setIsStatusUpdated(false); // 重置状态更新标记
    }
  }, [isStatusUpdated]);

  useEffect(() => {
    onOkSync();
  }, []);

  useEffect(() => {
    if (isUpGrade) {
      handlerSyncForce();
    }
  }, [isUpGrade]);

  const failContent = (code?: number) => {
    const getText = () => {
      if (code === 50002) {
        return getFormatMessage('higher_version_failure_desc');
      }
      if (code === 50003) {
        return getFormatMessage('missing_necessary_failure_desc');
      }
      if (code === 10014) {
        return getFormatMessage('operation_conflict_target');
      }
      if (code === 10015) {
        return getFormatMessage('operation_conflict_org');
      }
      return getFormatMessage('sync_fail');
    };
    return (
      <div className="content-box-fail">
        <img src={errorIcon} className="content-icon" />
        <div className="content">
          <div className="content-title">
            {getFormatMessage('synchronisation_failure')}
          </div>
          <span className="content-text">{getText()}</span>
          <Button
            className="gc-btn gc-btn-primary"
            onClick={() => {
              onCloseSyncTask();
            }}
          >
            {getFormatMessage('i_know')}
          </Button>
        </div>
      </div>
    );
  };

  // 停止
  const onPause = () => {
    clearInterval(intervalHandle.current as NodeJS.Timeout);
    console.log('定时器已关闭');
  };

  const onCloseSyncTask = async () => {
    console.log('isDone:', isDone);
    if (isDone) {
      setConfirmDiscardModal(true);
    } else {
      onPause();
      closeModal();
      setConfirmDiscardModal(false);
      setIsTargetHigh(false);
      setIsUpGrade(false);
    }
  };
  // 关闭抽屉二次确认
  const confirmDiscardChanges = async () => {
    onPause();
    closeModal();
    setConfirmDiscardModal(false);
    setIsTargetHigh(false);
    setIsUpGrade(false);
    return true;
  };

  return (
    <div>
      <Drawer
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{getFormatMessage('environment_sync')}</span>
            <img
              src={closeIcon}
              className="sync-close-icon"
              onClick={onCloseSyncTask}
            />
          </div>
        }
        placement="right"
        width={520}
        closable={false}
        onClose={onCloseSyncTask}
        visible={true}
        headerStyle={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          marginLeft: '3px',
        }}
        footer={''}
      >
        {isTargetHigh ? (
          modalContent
        ) : (
          <GameSyncStep steps={stepsSame} current={current} />
        )}

        {confirmDiscardModal && (
          <ModalWrap
            width="440px"
            // loading={loading}
            onOk={confirmDiscardChanges}
            cancelText={getFormatMessage('cancel')}
            onClose={() => {
              setConfirmDiscardModal(false);
            }}
            oKText={getFormatMessage('confirm')}
            title={
              <p className="fail-title">
                <img
                  src={warnImage}
                  alt="Warning"
                  style={{ marginRight: '10px', marginTop: '-2px' }}
                />
                <span>{getFormatMessage('discard_changes')}</span>
              </p>
            }
            className="delete-env-modal delete-modal"
          >
            <div style={{ whiteSpace: 'pre-line' }}>
              {getFormatMessage('sure_discard_changes')}
            </div>
          </ModalWrap>
        )}
      </Drawer>
    </div>
  );
};
